interface Props {
    isDeleted: boolean;
    value: string | number | React.ReactNode;
}

const DATA_STYLES = (isDeleted: boolean) => ({
    textDecoration: isDeleted ? 'line-through' : 'none',
    color: isDeleted ? '#bfbfbf' : 'inherit',
})

export const TableCellElement = (props: Props) => {
    return (
        <span style={DATA_STYLES(props.isDeleted)} >
            {props.value}
        </span >
    )
}
